(function () {
  const swiper = document.querySelector('.js-swiper');
  const loop = swiper.dataset.loop === 'true' ? true : false;
  const delay = parseInt(swiper.dataset.delay, 10);
  const autoplay = swiper.dataset.autoplay === 'true' ? { delay: delay, disableOnInteraction: false } : false

  // Swiper carousel
  new Swiper('.slider', {
    loop,
    autoplay,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  // Mobile image
  const slides = document.querySelectorAll('.js-slider__slide');
  
  Array.prototype.forEach.call(slides, function(slide) {
    if (slide.dataset.desktopBg && slide.dataset.mobileBg === '') {
      slide.style.cssText = `
        background-image: url(${slide.dataset.desktopBg});
        background-color: ${slide.dataset.colorBg};
      `;
    } else {
      let mobile = window.matchMedia('(min-width: 0px) and (max-width: 989px)');
      let desktop = window.matchMedia('(min-width: 990px)');

      /* On Load */
      window.addEventListener('load', function() {
        if(mobile.matches) {
          slide.style.cssText = `
            background-image: url(${slide.dataset.mobileBg});
            background-color: ${slide.dataset.colorBg};
          `;
        } else if(desktop.matches) {
          slide.style.cssText = `
            background-image: url(${slide.dataset.desktopBg});
            background-color: ${slide.dataset.colorBg};
          `;
        }
      });

      window.addEventListener('resize', function() {
        if(mobile.matches) {
          slide.style.cssText = `
            background-image: url(${slide.dataset.mobileBg});
            background-color: ${slide.dataset.colorBg};
          `;
        }  else if(desktop.matches) {
          slide.style.cssText = `
            background-image: url(${slide.dataset.desktopBg});
            background-color: ${slide.dataset.colorBg};
          `;
        }
      });
    }
  })
})();
